/**
 * EditPurchaseOrderWrapper
 *
 * Purpose:
 * - Wraps PO edit page to stay within vendor orders context.
 * - Uses returnTab for back navigation and intercepts default routes via history override.
 */
import React, { useEffect } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { SUPPLIERS, PURCHASE_ORDER, VENDOR, VENDOR_ORDERS } from "../../constants/route-paths";
import CreatePurchaseOrder from '../suppliers/purchase-order/create-po';
import { history } from "../../util/history";
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function EditPurchaseOrderWrapper(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();

  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.PURCHASE_ORDERS;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  // Custom cancel handler that redirects to vendor orders
  const customCancelHandler = () => {
    if (returnTab) {
      // Return to vendor orders with the correct tab and sub-tab
      let url = `/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}`;
      if (returnSubTab) {
        url += `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`;
      }
      navigate(url);
    } else {
      // Default to original supplier path
      navigate(`/${SUPPLIERS}/${PURCHASE_ORDER}`);
    }
  };

  useEffect(() => {
    // Store the original navigate function
    const originalNavigate = history.navigate;

    // Override the global history navigate function for any other navigation calls
    history.navigate = (path) => {
      if (returnTab && path === `/${SUPPLIERS}/${PURCHASE_ORDER}`) {
        // Return to vendor orders with the correct tab and sub-tab
        let url = `/${VENDOR}/${VENDOR_ORDERS}?${VENDOR_URL_PARAM.TAB}=${returnTab}`;
        if (returnSubTab) {
          url += `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}`;
        }
        navigate(url);
      } else {
        navigate(path);
      }
    };

    // Cleanup: restore the original function when component unmounts
    return () => {
      history.navigate = originalNavigate;
    };
  }, [navigate, returnTab, returnSubTab]);

  return (
    <CreatePurchaseOrder
      {...props}
      params={params}
      customCancelHandler={customCancelHandler}
    />
  );
}

export default EditPurchaseOrderWrapper;
